import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Card, Carousel, Col, Container, ListGroup, Row } from "react-bootstrap";

import ApiService from '../services/ApiService';
import OpenGamesWidgets from "../components/widgets/OpenGamesWidgets";

import { getGameAssetsUrl } from "../utilities/Helpers";

const HomePage = () => {
    const navigate = useNavigate();
    const [games, setGames] = useState<Game[]>();

    useEffect(() => {
        ApiService.get('/games/featured').then((response) => {
            if (!response) throw new Error('No response');
            if (response.success)
                setGames(response.data);
            else
                console.log(response.message);
        }).catch((error: any) => {
            console.log(error);
        });
    }, []);

    const FeaturedGames = () => {
        if (!games) return <>Loading featured games...</>;
        if (games?.length === 0) return <>No featured games</>;

        return (
            <Carousel>
                {
                    games.map((game) => {
                        let releaseDate = (game.releaseDate) ? new Date(game.releaseDate).toLocaleDateString() : "TBD";
                        let gameAssetsUrl = getGameAssetsUrl(game.id);
                        return (
                            <Carousel.Item key={game.id} className="">
                                <Row>
                                    <Col lg={8} className="carousel-image">
                                        <img src={`${gameAssetsUrl}/screenshot1.png`} alt="Screenshot 1" className="w-100 h-100" />
                                    </Col>
                                    <Col lg={4} className="pe-3">
                                        <h5 className="text-center">
                                            <img src={`${gameAssetsUrl}/logo.png`} alt={game.name} className="featured-logo" />
                                        </h5>
                                        <p className="fs-7 text-justify">
                                            {(game.description.length > 300 ? game.description.substring(0, 300) + '...' : game.description)}
                                        </p>
                                        <ListGroup variant="flush" className="fs-7">
                                            <ListGroup.Item className="bg-dark">
                                                Genre: {game.gameGenre.name}
                                            </ListGroup.Item>
                                            <ListGroup.Item className="bg-dark">
                                                Developer: {game?.publisher.name}
                                            </ListGroup.Item>
                                            <ListGroup.Item className="bg-dark">
                                                Release Date: {releaseDate}
                                            </ListGroup.Item>
                                        </ListGroup>
                                        <button onClick={() => navigate(`/game/${game.id}`)} className="dg-btn dg-btn-primary dg-btn-block text-light mt-5">Learn more</button>
                                    </Col>
                                </Row>
                            </Carousel.Item>
                        )
                    })
                }
            </Carousel>
        );
    };

    return (<>
        <Helmet>
            <title>Darknet Games</title>
        </Helmet>
        <div className="home mb-3">
            <Container>
                <Row className='g-3 mb-3'>
                    <Col>
                        <Card className='card-widget' id="library-widget">
                            <Card.Header>
                                Featured Games
                            </Card.Header>
                            <Card.Body className="library-games">
                                <FeaturedGames />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row className="mb-3 d-none d-md-block">
                    <Col>
                        <OpenGamesWidgets />
                    </Col>
                </Row>
            </Container>
        </div>
    </>);
}

export default HomePage;